// Patch ResizeObserver to prevent loop errors in PDF viewer
const RO = window.ResizeObserver;
window.ResizeObserver = class extends RO {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => { callback(entries, observer); });
    });
  }
};